import m from 'mithril';

import { sendVerifyEmail } from '../services/auth';
import { getAuthState } from '../services/authStore';
import { captureException } from '../services/sentry';
import { Alert } from '../components/Alert';
import { Button } from '../components/Button';
import { Loading } from '../components/Loading';
import { Type } from '../components/Typography';

/**
 * Email verification page.
 */
export const VerifyEmail: m.ClosureComponent = () => {
  const state = {
    resendClicked: false,
    error: '',
  };

  return {
    view: () => {
      const auth = getAuthState();

      if (auth.authLoading) {
        return m('section', { class: 'page page--centered' }, m(Loading, { large: true }));
      }

      if (!auth.firebaseUser) {
        m.route.set('/login/verifyemail');
        return null;
      }

      if (auth.firebaseUser.emailVerified) {
        m.route.set('/download/newUser');
        return null;
      }

      return m('section', { class: 'page verify-page' }, [
        m('div', { class: 'verify-page__icon', 'aria-hidden': 'true' }, '@'),
        m(Type, { size: 'title' }, 'Verify your email address'),
        m(Type, { className: 'verify-page__message' }, [
          "We've sent an email to ",
          m('code', auth.firebaseUser.email ?? 'your email address'),
          ' to verify your email address.',
          m('br'),
          'Click the link in that email to activate your account.',
        ]),
        state.error ? m(Alert, { variant: 'danger', message: state.error }) : null,
        state.resendClicked
          ? m(Type, { size: 'subheading', className: 'form-success' }, 'Email sent')
          : m(Button, {
            onclick: (event) => {
              event.redraw = false;
              state.resendClicked = true;
              state.error = '';
              void sendVerifyEmail()
                .catch((error: unknown) => {
                  captureException(error);
                  console.error('failed to send verification email:', error);
                  state.error = 'Unable to send verification email. Please try again.';
                })
                .finally(m.redraw);
            },
          }, 'Resend'),
      ]);
    },
  };
};
